export default "__VITE_ASSET__DtWrOs8B__"